export const selectRewardCode = (state) => state.reward.get('rewardCode');
